export default __webpack_public_path__ + "static/media/2.3f6a2b00.svg";